import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function BrandForge() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="BrandForge AI"
      teaser="An AI-powered graphic design template generator."
      imageSrc="/images/coming-soon/brandforge.png"
    />
    </div>
    </AppShell>
  );
}
